<template>
  <div class="activity-box">
    <el-tabs>
      <el-tab-pane class="activity-box__activity activity-box__panels" label="Mi actividad">
        <div class="activity-box__activity-items-container">
          <div class="activity-box__activity-items-header header">
            <input type="search" :placeholder='$t("common.search")' v-model="itemToSearch" @focus="focusHeader.activityTab = true"
                @focusout="focusHeader.activityTab = false">
            <el-dropdown trigger="click" placement="bottom-start">
                <i class="el-dropdown-link fas fa-filter"></i>
                <el-dropdown-menu slot="dropdown">
                    <el-checkbox-group v-model="activeFilter">
                        <el-dropdown-item v-for="item in filters" :key="item.value">
                            <el-checkbox :label="item.value">{{ item.label }}</el-checkbox>
                        </el-dropdown-item>
                    </el-checkbox-group>
                </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="activity-box__activity-items-container items-container">
            <recycle-scroller :items="activityListSorted" :item-size="26" key-field="key" v-slot="{ item }" v-if="getActivityList.length > 0"
                class='activity-box__activity-items items'>
                <the-activity-item :item="item"
                    :class="{ 'active': getActiveKey === item.key, 'new-call': item.active && item.type === 'call' }"
                    :data-id="item.key"  @click.native="changeActive" />
            </recycle-scroller>
            <div v-else style="text-align: center;">
                <p class="text-center">{{ $t('agent-console.no-activity') }}</p>
            </div>
          </div>
        </div>
      </el-tab-pane>
      
      <el-tab-pane v-if="agent.chat" label="Chats pendientes" class="activity-box__pending-chats activity-box__panels">
        <div class="activity-box__pending-chats-container">
          <div class="activity-box__pending-chats-header header">
            <input type="search" :placeholder='$t("common.search")' v-model="pendingChatToSearch" @focus="focusHeader.pendingChatsTab = true"
                @focusout="focusHeader.pendingChatsTab = false">
          </div>
          <div class="activity-box__pending-chats-items-container items-container">
            <recycle-scroller :items="pendingChats" :item-size="60" key-field="roomId" v-slot="{ item }"
              v-if="pendingChats.length > 0" class='activity-box__pending-chats items' @click.native="showAceptChatWindow">
              <the-pending-chat-item :title="item.nick ?? 'unknown'" :date="item.time" :type="item.type" :dept="item.dep_name"
                  :tags="item.tags" :data-id="item.roomId"></the-pending-chat-item>
            </recycle-scroller>
            <div v-else>
                <p class="text-center">{{ $t('agent-console.no-pending-chats') }}</p>
            </div>  
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import TheActivityItem from '@/components/agent-console/TheActivityItem';
import ThePendingChatItem from '@/components/agent-console/ThePendingChatItem';
import { RecycleScroller } from 'vue-virtual-scroller';
import { mapActions, mapGetters } from 'vuex';
export default{
  components: {
    TheActivityItem,
    ThePendingChatItem,
    RecycleScroller
  },
  data(){
    return {
      filters: [],
      pendingChatToSearch: '',
      focusHeader: {
        activityTab: false,
        pendingChatsTab: false
      }
    }
  },
  methods: {
    ...mapActions(['setActiveItem', 'setActiveItem', 'setPendingChatAcept', 'setShowAcceptPendingChat', 'resetUnreadMessages','updateActiveFilter', 'updateItemToSearch']),
    changeActive (event) {
      this.setShowAcceptPendingChat(false);

      if (this.activeItem) {
          if (this.activeItem.type === 'call') {
              this.$store.dispatch('agentConsoleCall/stopListeningToActiveCall', this.activeItem.key)
          }

          if (this.activeItem.type === 'chat') {
              this.$emit('select-chat');
              this.$store.dispatch('_chats/stopListenMessagesStatus', this.activeItem.data.roomId)
              this.$store.dispatch('_chats/stopListenInternalNotes', { roomId: this.activeItem.data.roomId })
              this.$store.dispatch('_chats/stopListenMessagesFromChatroom', { roomId: this.activeItem.data.roomId })
          }
      }

      const listItem = event.target.closest('li')
      console.log(listItem)
      if (!listItem) {
          return;
      }

      const item = this.getActivityList.find(item => item.key === listItem.dataset.id)

      console.log(item)
      if (item.type !== 'ticket') {
          if (item.type === 'chat') {
              const active = item.active
              const { roomId, unreadMessages = 0, lastMessage } = item.data
              //const chat = this.$store.getters['_chats/getChatByRoomId'](roomId)

              if (unreadMessages > 0) {
                  this.resetUnreadMessages(roomId)
              }

              this.$store.dispatch('agentConsoleChat/updateValues', roomId);
              this.$store.dispatch('_chats/listenInternalNotesFromChatroom', { roomId })

              if (active) {
                  /* if (chat) {
                      this.$store.dispatch('_chats/fetchAllMessagesFromChatroom', { roomId })
                  } */
                  this.$store.dispatch('_chats/fetchAndListenAllMessagesFromChat', { roomId })
              }

              if (!active && lastMessage) {
                  const { date } = lastMessage
                  this.$store.dispatch('_chats/fetchMessagesFromTimestamp', { roomId, date })
              }
              
              this.$emit('select-chat');

          }

          if (item.type === 'call') {
              this.$store.dispatch('agentConsoleCall/listenToCall', item.key);
          }

          this.setActiveItem(item.key)
      } else {
          this.$router.push({ name: 'ticket', params: { ticketNumber: item.number } })
      }
    },
    showAceptChatWindow (event) {
        const listItem = event.target.closest('li')

        if (!listItem) {
            return;
        }

        const item = this.pendingChats.find(item => item.roomId === listItem.dataset.id)

        this.setActiveItem(null)
        this.setPendingChatAcept(item);
        this.setShowAcceptPendingChat(true);
        console.log(item)
    },
    toggleFilter(filter) {
      let newFilters = [...this.$store.state.activeFilter]
      if (newFilters.includes(filter)) {
        newFilters = newFilters.filter(f => f !== filter)
      } else {
        newFilters.push(filter)
      }
      this.updateActiveFilter(newFilters)
    }
  },
  computed: {
    ...mapGetters(["getActivityList", "getAgent", "getActiveKey","getPendingChatsSorted"]),
    activityListSorted() {
      console.log(this.getActivityList)
      return this.getActivityList.toSorted((a, b) => new Date(b.date) - new Date(a.date))
    },
    pendingChats() {
      return this.getPendingChatsSorted.filter((element) => element.nick?.includes(this.pendingChatToSearch) || element.phone.includes(this.pendingChatToSearch))
    },
    activeItem () {
      return this.$store.getters['getActiveItem']
    },
    newMessage() {
      return this.getActivityList.filter(item => item.type === 'chat' && item.unreadMessages > 0).length
    },
    pendingChatsLength() {
      return this.pendingChats.length 
    },
    activityListLength() {
        return this.getActivityList.length
    },
    activeFilter: {
      get() {
          return this.$store.getters['getActiveFilters']
      },
      set(value) {
          this.$store.dispatch('updateActiveFilter', value)
      }
    },
    agent(){
      if (typeof this.getAgent === 'object') {
          return this.getAgent;
      }
      return null
    },
    itemToSearch: {
      get() {
          return this.$store.getters['getItemToSearch']
      },
      set(value) {
          this.updateItemToSearch(value)
      }
    }
  },
  watch: {
    pendingChatsLength(value, oldValue) {
        if (value > oldValue) {
            document.querySelector('#agent-pending-chat').play();
        }
    },
    activityListLength(value, oldValue) {
        if (value > oldValue) {
            document.querySelector('#agent-notifications')?.play();
        }
    },
    newMessage() {
        document.querySelector('#agent-notifications')?.play();
    }
  },
  created(){
    this.filters =  [
      { index: 'call', label: this.$t('agent-console.filters.call'), value: "call" },
      { index: 'chat', label: this.$t('agent-console.filters.chat_open'), value: "chat_open" },
      { index: 'chat', label: this.$t('agent-console.filters.chat_closed'), value: "chat_closed" },
      { index: 'chat', label: this.$t('agent-console.filters.chat_waiting_for_agent_answer'), value: "waiting_for_agent_answer" },
    ].filter((f) => this.getAgent[f.index])
  }
}
</script>
<style>
.activity-box .items li{
  padding: 10px;
  font-size: 12px !important;
}

.activity-box__activity-items li.active {
    border-radius: var(--radius);
    background-color: var(--light-blue);
}

.activity-box__activity-items li.new-call {
    background-color: var(--light-green);
}

.activity-box .activity-box__activity-items li h3 {
  font-size: 12px !important;
}
.activity-box .el-tabs__header .el-tabs__item{
  font-size: 12px;
}
.activity-box .items li {
  padding: 10px;
}

.activity-box .activity-box__pending-chats .item-header p{
  margin-bottom: 0;
}
.activity-box .activity-box__pending-chats p{
  font-size: 12px;
}
</style>
<style scoped>
.activity-box .header {
    align-items: baseline;
    border: 1px solid #dcdfe6;
    border-radius: var(--radius);
    display: inline-flex;
    justify-content: space-between;
    margin-bottom: var(--column);
    padding: calc(var(--column) / 2) var(--column);
    width: 100%;
}

.header input[type="search"] {
    flex: 1;
    border: none;
    width: 90%;
    font-size: 12px;
    background: none;
}

.header input[type="search"]:focus {
    outline: none;
}
.items-container{
  min-height: 270px;
  height: 100%;
  overflow-y: auto;
}
</style>